import React from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import { Error } from "../_common/Error";
import { Spinner } from "../_common/Spinner";

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <span>
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        type="search"
        className="form-control input-sm input-small input-inline"
      />
    </span>
  );
}

function Table({
  customFields,
  isLoading,
  error,
  setOpensidePanel,
  setCustomFieldDetails,
  confirmDelete,
}) {
  const columns = [
    {
      Header: "Field Name",
      accessor: "displayName",
      sortType: "basic",
    },
    {
      Header: "Field Type",
      accessor: "fieldType",
      sortType: "basic",
    },
    {
      Header: "Auto Pull",
      accessor: "autopull",
      sortType: "basic",
      Cell: ({ row }) => (
        <span>{row.original.autopull === 1 ? "On" : "Off"}</span>
      ),
    },
    {
      Header: "Action",
      accessor: "id",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <a
            className="edit"
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              setOpensidePanel(true);
              setCustomFieldDetails(row.original);
            }}
            style={{
              marginRight: "8px",
            }}
          >
            <i className="fa fa-pencil"></i>
          </a>
          <a
            className="delete"
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              confirmDelete(row.original);
            }}
            style={{ color: "#e7505a" }}
          >
            <i className="fa fa-trash-o"></i>
          </a>
        </div>
      ),
    },
  ];
  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  const hasCustomFields = customFields && customFields.length;
  if (!hasCustomFields) {
    return (
      <div>
        <h6 style={{ textAlign: "center", fontWeight: "bold" }}>
          All your Custom Fields will show here. Use the 'Add New +' button to
          add new field.
        </h6>
      </div>
    );
  }

  return <CustomFieldsTable customFields={customFields} columns={columns} />;
}

function CustomFieldsTable({ customFields, columns, updateMyData }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = React.useMemo(() => customFields, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      initialState: {
        sortBy: [
          {
            id: "displayName",
            desc: false,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy
  );

  return (
    <div className="dataTables_wrapper no-footer">
      <div className="dataTables_filter">
        <label>
          Search:
          {
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          }
        </label>
      </div>
      <table
        className="table table-striped table-hover table-bordered dataTable no-footer"
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  className={
                    !column.disableSortBy
                      ? column.isSorted
                        ? column.isSortedDesc
                          ? "sorting_desc"
                          : " sorting_asc"
                        : "sorting"
                      : ""
                  }
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export { Table };
